var minus = "https://shopfront-cdn.tekoapis.com/static/541582955daa66c1.svg";

export { minus as default };
